import React, { FC } from 'react'
import { StreamModalProps } from './types'
import Modal from '@bt-react/components/Modal'
import Button from '@bt-react/components/Button'
import styles from './StreamModal.module.scss'
import Icon, { IconType } from '@bt-react/components/Icon'
import Player from '@bt-react/components/Player'
import InputCopyToClipboard from '@bt-react/components/InputCopyToClipboard'

const StreamModal: FC<StreamModalProps> = ({
  isOpen,
  onCancelClick,
  streamUrl,
  streamKey,
  streamVideoUrl,
  showPassword,
  streamLoading,
  streamReady,
  launchStream,
  toggleShowPassword
}) =>
  <Modal
    className={styles['stream-modal']}
    isOpen={isOpen}
    concise={true}
    dataBdd='event-stream-modal'>
    <Modal.Header headerClasses={styles['stream-modal-header']}>
      Add stream
    </Modal.Header>
    <Modal.Body>
      <div className={styles['stream-modal-body-content']}>

        <div className={styles['stream-modal-inputs']}>
          <label className={ styles['stream-modal-label'] }>Stream URL - click to copy</label>
          <InputCopyToClipboard
            dataBdd={streamUrl === '' ? 'streamUrl-input-disabled' : 'streamUrl-input-enabled'}
            className={styles['stream-modal-input']}
            id={'stream-modal-url-copy'}
            link={streamUrl}
            textCopiedMsg='Stream url copied to clipboard'
            disabled={streamUrl === '' && true}
            placeholderText={streamUrl === '' ? 'Available 60 minutes before scheduled start time' : ''}
          />

          <label className={ styles['stream-modal-label'] }>Stream key - click to copy</label>
          <div className={ styles['stream-modal-password-wrapper'] }>
            <InputCopyToClipboard
              id='stream-modal-password-copy'
              className={styles['stream-modal-input']}
              dataBdd={showPassword ? 'stream-modal-input-password-shown' : 'stream-modal-input-password-hidden'}
              link={streamKey}
              inputType={showPassword ? 'input' : 'password'}
              textCopiedMsg='Stream key copied to clipboard'
              disabled={streamKey === '' && true}
              placeholderText={streamKey === '' ? 'Available 60 minutes before scheduled start time' : ''}
            />
            <span
              data-bdd='stream-modal-password-toggle'
              onClick={toggleShowPassword}
              className={styles['stream-modal-hide-password']}>
              <Icon
                name={showPassword ? IconType.iconName.eye : IconType.iconName.eyeSlash } />
            </span>
          </div>
        </div>

        <div className={styles['stream-modal-preview']}>
          <div className={styles['stream-modal-preview-window']}>
            { streamLoading && <Icon name={IconType.iconName.spinner} colour={'white'} />}
            { streamReady &&
              <Player
                controlsVisible={false}
                source={streamVideoUrl}
                muteAudio={true}
                streaming={true}
                disablePause={true}
              />
            }
          </div>
          <p className={styles['stream-modal-preview-info']}>
            <Icon
              name={IconType.iconName.infoCircle}
              className={styles['stream-modal-preview-info--icon']} />
            Enter the information to your left into your software’s settings.
          </p>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button
        dataBdd='stream-modal-launch-stream-button'
        className={styles['stream-modal-button']}
        onClick={launchStream}
        disabled={!streamReady}
        color={IconType.colour.primary}
      >
        Launch stream
      </Button>
      <Button
        dataBdd='stream-modal-cancel-button'
        className={styles['stream-modal-cancel-button']}
        onClick={onCancelClick}
        color={IconType.colour.white}
      >
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>

export default StreamModal